import { theme } from '@frontend/theme';

/** Scroll area height for the template grid; TODO: replace magic offset with layout tokens when shell/header height is standardized. */
export const TEMPLATE_GRID_HEIGHT = `calc(100vh - ${theme.spacing(50)})`;

export type TemplateFilter = 'all' | 'custom' | 'weave';
